"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookieValuesFromNextApiRequest = void 0;
const getCookieValuesFromNextApiRequest = (request, cookieNames) => {
    const result = {};
    for (const cookieName of cookieNames) {
        result[cookieName] = request.cookies[cookieName];
    }
    return result;
};
exports.getCookieValuesFromNextApiRequest = getCookieValuesFromNextApiRequest;
